import { SetUEEnvironment } from './../interfaces/setUEEnvironment';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Command, MessageType } from '../enums';
import { SetViewContextEvent, ViewContextState } from '../interfaces';
import { ViewContext } from './../enums/viewContext';
import { BoundaryToggle } from '../interfaces/boundaryToggle';

declare const sendToStreamer: any;

@Injectable({
	providedIn: 'root',
})
export class BoundaryService {
	public toggleBoundaries: BehaviorSubject<[boolean, boolean]> = new BehaviorSubject<
		[boolean, boolean]
	>([true, false]);
	public viewContextState: BehaviorSubject<ViewContextState> =
		new BehaviorSubject<ViewContextState>({
			CurrentFocus: ViewContext.City,
			Country: 'UAE',
			City: '',
			Community: '',
			Sector: '',
			Plot: '',
			Building: '',
			Floor: '',
			Unit: '',
			Asset: '',
		});
	constructor() {
		this.toggleBoundaries.subscribe((state) => {
			this.boundaryToggle();
		});
		this.viewContextState.subscribe((state) => {
			this.boundaryToggle();
		});
	}

	boundaryToggle(): void {
		if (this.toggleBoundaries.value[1] === false) return;
		const currentViewContext = structuredClone(this.viewContextState.value);
		const message: SetViewContextEvent = {
			type: MessageType.notif,
			cmd: Command.BoundaryVisibility,
			msg: {
				visibility: this.toggleBoundaries.value[0],
				ViewContext: currentViewContext.context
					? currentViewContext.context
					: ViewContext.Country,
			} as BoundaryToggle,
		};
		try {
			console.log('Boundary:', message);
			sendToStreamer(message);
		} catch (error) {
			console.error('ViewContext not sent', message);
		}
	}

	streamSetUEEnv(msg: SetUEEnvironment) {
		const message: SetViewContextEvent = {
			type: MessageType.notif,
			cmd: Command.SetEnvironment,
			msg: msg,
		};
		try {
			sendToStreamer(message);
		} catch (error) {
			console.error('ViewContext not sent', message);
		}
	}
}
